import { ParticipantCircle } from '../../types/participant';

export enum StackDirection {
  UP = 'up',
  DOWN = 'down',
  LEFT = 'left',
}
export const flexDirectionByStackDirection = {
  [StackDirection.UP]: 'column-reverse',
  [StackDirection.DOWN]: 'column',
  [StackDirection.LEFT]: 'row',
};

export const icons: Partial<Record<StackDirection, ParticipantCircle[]>> = {
  [StackDirection.DOWN]: [{ emoji: '🦢', color: '#FFCF03' }, { emoji: '☕', color: '#FF653F' },
    { emoji: '☕', color: '#00C070' }, { emoji: '🦢', color: '#4244AF' }],
  [StackDirection.UP]: [{ emoji: '🦢', color: '#FFCEB9' }, { emoji: '☕', color: '#FF653F' },
    { emoji: '☕', color: '#FF653F' }, { emoji: '👟', color: '#EB73EF' }],
};
